import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'

export const Seal = {
  namespaced: true,
  state: {
    campaigns: [],
    is_new_plate: 0
  },
  getters: {
    campaigns: state => state.campaigns,
    is_new_plate: state => state.is_new_plate
  },
  mutations: {
    UPDATE_SEALS(state, payload) {
      state.campaigns = payload['campaigns']
    },
    UPDATE_ISNEWPLATE(state, payload) {
      state.is_new_plate = payload
    }
  },
  actions: {
    /**
     * 現在開催中のキャンペーン情報とクーポン使用有無 シールのリストの取得
     *
     * @param {*} param0
     * @param {*} payload
     */
    async actionFetchSeals({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      let res = null
      if (token !== '') {
        res = await APIClient.getSeal(token, accTime, userId)
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        const campaigns = res.data['data']['campaigns']
        commit('UPDATE_SEALS', res.data.data)
        //commit('UPDATE_SEALSCOUNT', campaigns[0].seals.length)
        localStorage.setItem('isEndAt', campaigns[0].end_at)
        console.log("-- seals_count:" + campaigns[0].seals.length)
        const local = localStorage.getItem('isShowNewPlate')
        console.log("-- local 0:" + local)
        if (local === null) {
          localStorage.setItem('isShowNewPlate', campaigns[0].seals.length)
          const local = localStorage.getItem('isShowNewPlate')
          console.log("-- local 1:" + local)
        }
        if(campaigns[0].seals.length > 0 ) {
          if (local !== String(campaigns[0].seals.length)) {
            localStorage.setItem('isShowNewPlate', campaigns[0].seals.length)
            //localStorage.setItem('isShowNewPlate', 2)
            const local = localStorage.getItem('isShowNewPlate')
            commit('UPDATE_ISNEWPLATE', 1)
            console.log("-- local 2:" + local)
          }
          else {
            commit('UPDATE_ISNEWPLATE', 0)
          }
        }
        else {
          commit('UPDATE_ISNEWPLATE', 0)
        }
      } else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    }
  }
}
